import { getOneTrustDenyByDefault, isOneTrustActive } from './onetrust-handler';
const ALLOW_COOKIES_HEADER = 'X-Allow-Cookies';
const BLOCK_COOKIES_HEADER = 'X-Block-Cookies';
export const OneTrustEnvoyHeaderHandler = {
    ALLOW_COOKIES_HEADER,
    BLOCK_COOKIES_HEADER,
    get allowCookiesHeaderValue() {
        if (!isOneTrustActive()) {
            return '';
        }
        return globalThis.OnetrustActiveGroups;
    },
    get shouldAddBlockCookieHeader() {
        return isOneTrustActive() || getOneTrustDenyByDefault();
    },
};
//# sourceMappingURL=headers.js.map